export default __webpack_public_path__ + "static/media/E25.9d6ad7a5.jpeg";